(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alborg-lp"]) return;
  try {
    
(function () {
  function init() {
    var root = document.getElementById('alb-root');
    if (!root || root.dataset.albInit) return;
    root.dataset.albInit = '1';

    var $ = function (id) { return root.querySelector('#' + id); };
    var qsa = function (s) { return root.querySelectorAll(s); };
    var each = function (l, fn) { Array.prototype.forEach.call(l, fn); };
    var esc = function (s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };
    var fill = function (tpl, map) {
      /* [token] is the documented form. {{ token }} is still honoured so any value a
         merchant saved before Shopify rejected braces in schema defaults keeps working. */
      return String(tpl || '')
        .replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return map[k] == null ? '' : String(map[k]); })
        .replace(/\[(\w+)\]/g, function (m, k) { return map[k] == null ? m : String(map[k]); });
    };
    var readJSON = function (id, dflt) {
      var el = $(id);
      if (!el) return dflt;
      try { return JSON.parse(el.textContent); } catch (e) { return dflt; }
    };

    var S = readJSON('alb-strings', {});
    var variants = readJSON('alb-variants', []);
    var MTO = readJSON('alb-mto', null);
    if (!variants.length) return;

    var T_ADD = root.getAttribute('data-t-add') || 'Add to cart';
    var T_CHOOSE = root.getAttribute('data-t-choose') || 'Choose a size';
    var PRICE_FROM = root.getAttribute('data-price-from') || '';

    /* ------------------------------------------------------------------
       One product option carries colour, neck, chest and the adjustment
       range in a single string:
         "Milk Chocolate Neck 10\" Chest 12\" (Adjusts from 11\" to 13\")"
       A few values on the store are missing the closing bracket, so it is
       optional here. Everything downstream is derived from this parse, which
       is why price, stock and ranges never need hand-maintaining.
       ------------------------------------------------------------------ */
    var sizeHost = $('alb-sizes');
    var optIdx = sizeHost ? parseInt(sizeHost.getAttribute('data-option-index'), 10) : 0;
    if (isNaN(optIdx)) optIdx = 0;

    var RE = /^\s*(.*?)\s*Neck\s*([\d.]+)\s*"?\s*Chest\s*([\d.]+)\s*"?\s*\(?\s*Adjusts\s*from\s*([\d.]+)\s*"?\s*to\s*([\d.]+)\s*"?\)?\s*$/i;

    function parseOpt(value) {
      var m = String(value).match(RE);
      if (!m) return null;
      return {
        colour: m[1].trim(), neck: parseFloat(m[2]), chest: parseFloat(m[3]),
        lo: parseFloat(m[4]), hi: parseFloat(m[5])
      };
    }

    // rows: one per variant that parses, plus its live price and availability
    var rows = [];
    var colours = [];
    variants.forEach(function (v) {
      var raw = v.options[optIdx];
      var p = parseOpt(raw);
      if (!p) return;
      rows.push({
        id: v.id, value: raw, colour: p.colour, neck: p.neck, chest: p.chest,
        lo: p.lo, hi: p.hi, price: v.price, raw: v.raw,
        available: v.available, image: v.image || null
      });
      if (colours.indexOf(p.colour) === -1) colours.push(p.colour);
    });
    if (!rows.length) return;

    // distinct sizes, ordered by chest then neck, so the chart reads sensibly
    var sizes = [];
    rows.forEach(function (r) {
      var key = r.neck + '|' + r.chest;
      if (!sizes.some(function (s) { return s.key === key; })) {
        sizes.push({ key: key, neck: r.neck, chest: r.chest });
      }
    });
    sizes.sort(function (a, b) { return (a.chest - b.chest) || (a.neck - b.neck); });

    function rowFor(neck, chest, colour) {
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        if (r.neck === neck && r.chest === chest && r.colour === colour) return r;
      }
      return null;
    }

    var SUITS = {};
    String(S.suits || '').split('|').forEach(function (pair) {
      var bits = pair.split('::');
      if (bits.length === 2) SUITS[bits[0].trim()] = bits[1].trim();
    });
    var BANDS = [];
    String(S.bands || '').split('|').forEach(function (b) {
      var bits = b.split('::');
      if (bits.length >= 3) {
        BANDS.push({ label: bits[0].trim(), note: bits[1].trim(), max: parseFloat(bits[2]) });
      }
    });

    var SWATCH = [
      [/chocolate|brown/i, 'conic-gradient(#6B4429 180deg, #C9A84C 180deg)'],
      [/cream/i, 'conic-gradient(#E4D6BE 180deg, #A8823E 180deg)'],
      [/cognac/i, '#8B5E3C'],
      [/red/i, 'conic-gradient(#A32A2A 180deg, #1C1A18 180deg)'],
      [/pink|purple/i, 'conic-gradient(#D4527E 180deg, #5C3A6E 180deg)'],
      [/blue/i, 'conic-gradient(#2BA3BF 180deg, #1C1A18 180deg)'],
      [/olive|green/i, 'conic-gradient(#4A5240 180deg, #C9A84C 180deg)'],
      [/black/i, 'conic-gradient(#1A1A1A 180deg, #909AA0 180deg)']
    ];
    function swatchFor(name) {
      for (var i = 0; i < SWATCH.length; i++) if (SWATCH[i][0].test(name)) return SWATCH[i][1];
      return '#8B6245';
    }

    var state = { colour: null, neck: null, chest: null };
    var seedRow = rows.filter(function (r) { return r.available; })[0] || rows[0];
    state.colour = seedRow.colour;

    var lbl = function (neck, chest) { return fill(S.sizeFmt, { neck: neck, chest: chest }); };
    var adjLbl = function (r) { return fill(S.adjFmt, { lo: r.lo, hi: r.hi }); };

    /* ---------------- gallery ---------------- */
    var stage = $('alb-stage');
    var vid = stage ? stage.querySelector('video') : null;
    var mainImg = $('alb-main-img');
    var stickyImg = $('alb-sticky-img');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var posterSrc = null;
    var vthumb = root.querySelector('.thumb[data-kind="video"] img');
    if (vthumb) posterSrc = vthumb.getAttribute('src');

    function markThumb(pred) { each(qsa('.thumb'), function (t) { t.classList.toggle('active', pred(t)); }); }
    function showVideo() {
      if (!stage) return;
      stage.classList.remove('on-image');
      if (stickyImg && posterSrc) stickyImg.src = posterSrc;
      markThumb(function (t) { return t.getAttribute('data-kind') === 'video'; });
      if (vid && !reduce && vid.paused) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
      setPauseLabel();
    }
    function setImage(url, alt) {
      if (!url || !stage || !mainImg) return;
      if (mainImg.getAttribute('src') !== url) {
        mainImg.src = url;
        mainImg.alt = alt || '';
        mainImg.removeAttribute('aria-hidden');
      }
      stage.classList.add('on-image');
      if (vid && !vid.paused) vid.pause();
      if (stickyImg) stickyImg.src = url;
      markThumb(function (t) { return t.getAttribute('data-full') === url; });
    }
    each(qsa('.thumb'), function (t) {
      t.addEventListener('click', function () {
        if (t.getAttribute('data-kind') === 'video') showVideo();
        else setImage(t.getAttribute('data-full'), t.getAttribute('data-alt'));
      });
    });

    /* Swipe / drag the stage to move through the gallery. Touch and mouse both
       run on pointer events; `touch-action: pan-y` hands us horizontal gestures
       while leaving vertical page scrolling to the browser. */
    var thumbs = qsa('.thumb');
    var strip = $('alb-thumbs');

    function activeIndex() {
      for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].classList.contains('active')) return i; }
      return 0;
    }
    function revealThumb(t) {
      if (!strip || !t) return;
      var tr = t.getBoundingClientRect(), sr = strip.getBoundingClientRect();
      if (tr.left < sr.left) strip.scrollLeft -= (sr.left - tr.left) + 12;
      else if (tr.right > sr.right) strip.scrollLeft += (tr.right - sr.right) + 12;
    }
    function goTo(i) {
      if (!thumbs.length) return;
      if (i < 0) i = thumbs.length - 1;
      if (i > thumbs.length - 1) i = 0;
      var t = thumbs[i];
      if (t.getAttribute('data-kind') === 'video') showVideo();
      else setImage(t.getAttribute('data-full'), t.getAttribute('data-alt'));
      revealThumb(t);
    }

    if (stage && thumbs.length > 1) {
      var media = stage.querySelectorAll('video, img');
      var sx = 0, sy = 0, dx = 0, pid = null, tracking = false, horizontal = false;

      function nudge(px) {
        each(media, function (m) { m.style.transform = px ? 'translateX(' + px + 'px)' : ''; });
      }
      function release(commit) {
        if (!tracking) return;
        tracking = false;
        stage.classList.remove('dragging');
        if (horizontal) {
          each(media, function (m) { m.style.transition = 'transform .18s ease-out'; });
          nudge(0);
          setTimeout(function () { each(media, function (m) { m.style.transition = ''; }); }, 220);
          if (commit && Math.abs(dx) > 45) goTo(activeIndex() + (dx < 0 ? 1 : -1));
        }
        horizontal = false; dx = 0; pid = null;
      }

      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target && e.target.closest && e.target.closest('.hero-pause')) return;
        pid = e.pointerId; sx = e.clientX; sy = e.clientY; dx = 0;
        tracking = true; horizontal = false;
        each(media, function (m) { m.style.transition = ''; });
      });

      stage.addEventListener('pointermove', function (e) {
        if (!tracking || e.pointerId !== pid) return;
        var mx = e.clientX - sx, my = e.clientY - sy;
        if (!horizontal) {
          if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
          /* Vertical intent wins: stand down so the page scrolls normally. */
          if (Math.abs(my) >= Math.abs(mx)) { tracking = false; pid = null; return; }
          horizontal = true;
          stage.classList.add('dragging');
          if (stage.setPointerCapture) { try { stage.setPointerCapture(pid); } catch (err) {} }
        }
        dx = mx;
        if (e.cancelable) e.preventDefault();
        nudge(Math.max(-70, Math.min(70, dx * 0.5)));
      });

      each(['pointerup', 'pointercancel'], function (ev) {
        stage.addEventListener(ev, function (e) {
          if (e.pointerId !== pid) return;
          release(ev === 'pointerup');
        });
      });
      stage.addEventListener('pointerleave', function () { if (!horizontal) release(false); });
      stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    /* Arrow keys step the strip once a thumbnail has focus. */
    if (strip && thumbs.length > 1) {
      strip.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowLeft' ? -1 : 0);
        if (!d) return;
        e.preventDefault();
        var i = activeIndex() + d;
        if (i < 0) i = thumbs.length - 1;
        if (i > thumbs.length - 1) i = 0;
        goTo(i);
        thumbs[i].focus();
      });
    }

    var vtoggle = $('alb-vtoggle');
    function setPauseLabel() {
      if (!vtoggle || !vid) return;
      var playing = !vid.paused;
      vtoggle.setAttribute('aria-label', playing
        ? (vtoggle.getAttribute('data-t-pause') || 'Pause')
        : (vtoggle.getAttribute('data-t-play') || 'Play'));
      vtoggle.innerHTML = playing
        ? '<svg width="11" height="12" viewBox="0 0 11 12" fill="currentColor" aria-hidden="true"><rect x="0" y="0" width="3.4" height="12"/><rect x="7.6" y="0" width="3.4" height="12"/></svg>'
        : '<svg width="11" height="12" viewBox="0 0 13 14" fill="currentColor" aria-hidden="true"><path d="M0 0l13 7-13 7z"/></svg>';
    }
    if (vtoggle && vid) {
      vtoggle.addEventListener('click', function () {
        if (vid.paused) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); } else { vid.pause(); }
        setPauseLabel();
      });
      vid.addEventListener('play', setPauseLabel);
      vid.addEventListener('pause', setPauseLabel);
      if (vid.hasAttribute('autoplay') && reduce) vid.removeAttribute('autoplay');
      if (!reduce) { var pp = vid.play(); if (pp && pp.catch) pp.catch(function () {}); }
      setPauseLabel();
    }

    /* ---------------- buy box ---------------- */
    var swatchHost = $('alb-swatches');
    function buildSwatches() {
      if (!swatchHost) return;
      swatchHost.innerHTML = '';
      colours.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sw' + (c === state.colour ? ' active' : '');
        b.setAttribute('data-value', c);
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', c === state.colour ? 'true' : 'false');
        b.setAttribute('aria-label', c);
        b.title = c;
        var r = state.neck != null ? rowFor(state.neck, state.chest, c) : null;
        if (r && !r.available) b.setAttribute('data-oos', '1');
        b.innerHTML = '<i style="background:' + swatchFor(c) + '"></i>';
        b.addEventListener('click', function () {
          state.colour = c;
          var pick = state.neck != null ? rowFor(state.neck, state.chest, c) : null;
          if (pick && pick.image) setImage(pick.image, c);
          refresh();
        });
        swatchHost.appendChild(b);
      });
    }

    function bandOf(chest) {
      for (var i = 0; i < BANDS.length; i++) if (chest <= BANDS[i].max) return BANDS[i];
      return BANDS.length ? BANDS[BANDS.length - 1] : null;
    }

    function buildSizes() {
      if (!sizeHost) return;
      sizeHost.innerHTML = '';
      var groups = [];
      sizes.forEach(function (s) {
        var b = bandOf(s.chest);
        var key = b ? b.label : '';
        var g = groups.filter(function (x) { return x.key === key; })[0];
        if (!g) { g = { key: key, note: b ? b.note : '', items: [] }; groups.push(g); }
        g.items.push(s);
      });
      groups.forEach(function (g) {
        var wrap = document.createElement('div');
        wrap.className = 'size-group';
        if (groups.length > 1 && g.key) {
          var h = document.createElement('div');
          h.className = 'size-group-h';
          h.innerHTML = '<span>' + esc(g.key) + '</span><em>' + esc(g.note) + '</em>';
          wrap.appendChild(h);
        }
        var grid = document.createElement('div');
        grid.className = 'size-grid';
        g.items.forEach(function (s) {
          var r = rowFor(s.neck, s.chest, state.colour);
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'size-btn' + (state.neck === s.neck && state.chest === s.chest ? ' active' : '');
          btn.disabled = !r || !r.available;
          if (btn.disabled) btn.title = S.soldOut || 'Sold out';
          else btn.title = lbl(s.neck, s.chest) + ' · ' + adjLbl(r);
          btn.innerHTML = '<span class="len">' + s.neck + '″ / ' + s.chest + '″</span>' +
                          '<span class="wid">' + esc(r ? r.price : '') + '</span>';
          btn.addEventListener('click', function () { pickSize(s.neck, s.chest, false); });
          grid.appendChild(btn);
        });
        wrap.appendChild(grid);
        sizeHost.appendChild(wrap);
      });
    }

    var tbody = $('alb-size-rows');
    function buildTable() {
      if (!tbody) return;
      tbody.innerHTML = '';
      var prevHi = null;
      sizes.forEach(function (s) {
        var r = rowFor(s.neck, s.chest, state.colour);
        if (!r) return;
        // surface a coverage hole between stocked adjustment ranges
        if (prevHi != null && r.lo - prevHi > 1 && S.gapRow) {
          var gap = document.createElement('tr');
          gap.className = 'size-gap';
          gap.innerHTML = '<td colspan="6">' + esc(fill(S.gapRow, { from: prevHi, to: r.lo })) + '</td>';
          tbody.appendChild(gap);
        }
        prevHi = r.hi;
        var tr = document.createElement('tr');
        if (!r.available) tr.className = 'gone';
        tr.innerHTML =
          '<td>' + s.neck + '″</td>' +
          '<td>' + s.chest + '″</td>' +
          '<td>' + esc(adjLbl(r)) + '</td>' +
          '<td>' + esc(SUITS[s.key] || '') + '</td>' +
          '<td>' + esc(r.price) + '</td>' +
          '<td><button type="button" class="pick"' + (r.available ? '' : ' disabled') + '>' +
          esc(r.available ? (S.select || 'Select') : (S.soldOut || 'Sold out')) + '</button></td>';
        var btn = tr.querySelector('.pick');
        if (btn && r.available) {
          btn.addEventListener('click', function () { pickSize(s.neck, s.chest, true); });
        }
        tbody.appendChild(tr);
      });
    }

    var stickySel = $('alb-sticky-size');
    function buildSelect() {
      if (!stickySel) return;
      stickySel.innerHTML = '';
      var o0 = document.createElement('option');
      o0.value = ''; o0.textContent = S.chooseSize || T_CHOOSE;
      stickySel.appendChild(o0);
      sizes.forEach(function (s) {
        var r = rowFor(s.neck, s.chest, state.colour);
        if (!r) return;
        var o = document.createElement('option');
        o.value = s.key;
        o.textContent = lbl(s.neck, s.chest) + ' — ' + r.price + (r.available ? '' : ' · ' + (S.soldOut || ''));
        o.disabled = !r.available;
        stickySel.appendChild(o);
      });
      stickySel.value = state.neck != null ? (state.neck + '|' + state.chest) : '';
    }
    if (stickySel) {
      stickySel.addEventListener('change', function () {
        if (!this.value) return;
        var b = this.value.split('|');
        pickSize(parseFloat(b[0]), parseFloat(b[1]), false);
      });
    }

    function pickSize(neck, chest, scroll) {
      state.neck = neck; state.chest = chest;
      var r = rowFor(neck, chest, state.colour);
      if (!r || !r.available) {
        // move to a colour that has this size in stock rather than dead-ending
        var open = rows.filter(function (x) {
          return x.neck === neck && x.chest === chest && x.available;
        })[0];
        if (open) state.colour = open.colour;
      }
      refresh();
      if (scroll) {
        var box = $('alb-buybox');
        if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
        toast(fill(S.sizeSetToast, { size: lbl(neck, chest) }));
      }
    }

    var idInput = $('alb-variant-id');
    var atc = $('alb-atc');
    var stickyBtn = $('alb-sticky-btn');

    function refresh() {
      buildSwatches(); buildSizes(); buildTable(); buildSelect();
      var r = state.neck != null ? rowFor(state.neck, state.chest, state.colour) : null;
      var label = $('alb-colour-label');
      if (label) label.textContent = state.colour || '';
      if (idInput && r) idInput.value = r.id;
      var priceEl = $('alb-price'), noteEl = $('alb-price-note'), finalEl = $('alb-final-price');
      if (priceEl) priceEl.textContent = r ? r.price : PRICE_FROM;
      if (noteEl && r) noteEl.textContent = lbl(state.neck, state.chest) + ' · ' + adjLbl(r);
      if (finalEl) finalEl.textContent = r ? r.price : PRICE_FROM;
      var sm = $('alb-sticky-m'), sp = $('alb-sticky-price');
      if (sm) sm.textContent = (state.colour || '') + (r ? ' · ' + lbl(state.neck, state.chest) : '');
      if (sp) sp.textContent = r ? r.price : PRICE_FROM;
      if (atc) {
        atc.textContent = r ? T_ADD : T_CHOOSE;
        atc.disabled = false;
      }
      if (stickyBtn) stickyBtn.textContent = r ? T_ADD : T_CHOOSE;
    }

    // no size chosen yet: block submit and point at the picker
    var form = $('alb-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var r = state.neck != null ? rowFor(state.neck, state.chest, state.colour) : null;
        if (!r) {
          e.preventDefault();
          var box = $('alb-buybox');
          if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (sizeHost) {
            sizeHost.classList.remove('flash');
            void sizeHost.offsetWidth;
            sizeHost.classList.add('flash');
          }
          toast(S.pickFirst || '');
        }
      });
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }

    /* ---------------- toast ---------------- */
    var tTimer;
    function toast(msg) {
      if (!msg) return;
      var t = $('alb-toast'), tt = $('alb-toast-t');
      if (!t || !tt) return;
      tt.textContent = msg;
      t.classList.add('on');
      clearTimeout(tTimer);
      tTimer = setTimeout(function () { t.classList.remove('on'); }, 2700);
    }

    /* ---------------- sticky reveal ---------------- */
    var sticky = $('alb-sticky');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        var past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        sticky.classList.toggle('on', past);
      }, { threshold: 0 }).observe(atc);
    }

    /* ---------------- faq ---------------- */
    each(qsa('.faq-q'), function (q) {
      q.addEventListener('click', function () {
        var open = q.parentNode.classList.toggle('open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ==========================================================
       FIT FINDER
       ========================================================== */
    var scrim = $('alb-qscrim');
    if (!scrim) { refresh(); return; }

    var Q = { step: 1, neck: null, chest: null, coat: 'short', grow: 'no', pick: null, colour: null, mto: null };
    var STEPS = 5;
    var nextBtn = $('alb-qnext');

    function tLabel(k, dflt) { return (nextBtn && nextBtn.getAttribute('data-t-' + k)) || dflt; }

    function showStep(n) {
      Q.step = n;
      each(qsa('.qstep'), function (s) { s.classList.toggle('on', parseInt(s.getAttribute('data-s'), 10) === n); });
      var bar = $('alb-qbar');
      if (bar) bar.style.width = Math.round(n / STEPS * 100) + '%';
      var back = $('alb-qback');
      if (back) back.style.visibility = n === 1 ? 'hidden' : 'visible';
      var skip = $('alb-qskip');
      if (skip) skip.style.display = n === 5 ? 'none' : '';
      if (nextBtn) {
        nextBtn.textContent = n === 1 ? tLabel('start', 'Start')
          : n === 4 ? tLabel('show', 'Show my size')
          : n === 5 ? tLabel('use', 'Use this size')
          : tLabel('next', 'Continue');
      }
      var f = n === 2 ? 'alb-in-neck' : (n === 3 ? 'alb-in-chest' : null);
      if (f) setTimeout(function () { var el = $(f); if (el) el.focus(); }, 80);
    }
    function openQuiz() {
      scrim.hidden = false;
      scrim.classList.add('on');
      document.body.style.overflow = 'hidden';
      showStep(Q.step);
    }
    function closeQuiz() {
      scrim.classList.remove('on');
      document.body.style.overflow = '';
      setTimeout(function () { if (!scrim.classList.contains('on')) scrim.hidden = true; }, 240);
    }
    each(qsa('.alb-quiz-open'), function (b) { b.addEventListener('click', openQuiz); });
    var qclose = $('alb-qclose');
    if (qclose) qclose.addEventListener('click', closeQuiz);
    scrim.addEventListener('click', function (e) { if (e.target === scrim) closeQuiz(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && scrim.classList.contains('on')) closeQuiz();
    });
    var know = $('alb-know-already');
    if (know) know.addEventListener('click', function () {
      var f = $('alb-fit'); if (f) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    var qskip = $('alb-qskip');
    if (qskip) qskip.addEventListener('click', function () {
      closeQuiz();
      var f = $('alb-fit'); if (f) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
      toast(S.chartToast || '');
    });

    each(qsa('.qopts'), function (g) {
      var key = g.getAttribute('data-g');
      each(g.querySelectorAll('.qopt'), function (b) {
        b.addEventListener('click', function () {
          each(g.querySelectorAll('.qopt'), function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          Q[key] = b.getAttribute('data-v');
        });
      });
    });

    /* ---- the matching rule ----
       1. keep every size whose published chest range contains the measurement
       2. of those, keep only sizes whose neck is at or above the measured neck.
          A neck smaller than the dog's does not buckle, so it is never offered
       3. take the smallest of those that is in stock in the chosen colour
       4. a long coat or a growing dog bumps to the next size up when that size
          also still holds the chest measurement
       Failures return a reason so the result screen can say whether it is a
       stock problem, a gap between stocked ranges, or a shape not covered. */
    function fit(colour) {
      var all = rows.filter(function (r) {
        return r.colour === colour && Q.chest >= r.lo && Q.chest <= r.hi;
      });
      if (!all.length) return { ok: false, why: 'gap' };
      all.sort(function (a, b) { return a.neck - b.neck; });
      var enough = all.filter(function (r) { return r.neck >= Q.neck; });
      if (!enough.length) return { ok: false, why: 'neck' };
      var stocked = enough.filter(function (r) { return r.available; });
      if (!stocked.length) return { ok: false, why: 'stock', want: enough[0] };
      var hit = stocked[0];
      if (Q.coat === 'long' || Q.grow === 'yes') {
        var up = stocked[1];
        var nearTop = Q.chest >= (hit.hi - 0.5);
        if (up && (nearTop || Q.grow === 'yes')) hit = up;
      }
      return { ok: true, hit: hit };
    }
    function nearest(colour) {
      var best = null, bd = 1e9;
      rows.forEach(function (r) {
        if (r.colour !== colour || !r.available) return;
        var d = Q.chest < r.lo ? r.lo - Q.chest : (Q.chest > r.hi ? Q.chest - r.hi : 0);
        if (d < bd) { bd = d; best = { r: r, d: d }; }
      });
      return best;
    }
    function tick() {
      return '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" stroke="#8B6245" stroke-width="1.6" aria-hidden="true"><path d="M1.6 6.8l3 3L11.4 3"/></svg>';
    }

    /* ---- made to order: bands parsed from that product's own options ---- */
    var MTO_BANDS = [];
    if (MTO && MTO.variants) {
      var MRE = /Neck\s*Size\s*From\s*\(?\s*([\d.]+)\s*"?\s*to\s*([\d.]+)\s*"?\)?\s*and\s*Girth\s*from\s*\(?\s*([\d.]+)\s*"?\s*to\s*([\d.]+)\s*"?\)?/i;
      MTO.variants.forEach(function (v) {
        var colour = null, band = null;
        v.options.forEach(function (o) {
          var m = String(o).match(MRE);
          if (m) band = { n0: +m[1], n1: +m[2], g0: +m[3], g1: +m[4] };
          else if (!colour) colour = String(o).trim();
        });
        if (band) {
          MTO_BANDS.push({
            id: v.id, colour: colour, price: v.price, available: v.available,
            n0: band.n0, n1: band.n1, g0: band.g0, g1: band.g1
          });
        }
      });
    }
    function mtoColourFor(colour) {
      var first = String(colour || '').split(' ')[0].toLowerCase();
      var exact = MTO_BANDS.filter(function (b) { return (b.colour || '').toLowerCase() === String(colour).toLowerCase(); });
      if (exact.length) return exact;
      var loose = MTO_BANDS.filter(function (b) { return (b.colour || '').toLowerCase().indexOf(first) === 0; });
      return loose.length ? loose : MTO_BANDS;
    }
    function mtoBand(colour) {
      var pool = mtoColourFor(colour).filter(function (b) { return b.available; });
      if (!pool.length) return null;
      var both = pool.filter(function (b) {
        return Q.neck >= b.n0 && Q.neck <= b.n1 && Q.chest >= b.g0 && Q.chest <= b.g1;
      });
      if (both.length) return { band: both[both.length - 1], exact: true };
      var byGirth = pool.filter(function (b) { return Q.chest >= b.g0 && Q.chest <= b.g1; });
      if (byGirth.length) return { band: byGirth[byGirth.length - 1], exact: false };
      return null;
    }
    function mtoLink(band) {
      var base = (MTO && MTO.url) || root.getAttribute('data-mto-url') || '';
      if (!base) return '';
      return band ? base + '?variant=' + band.id : base;
    }
    function bandLabel(b) {
      return fill(S.mtoRowBand, { n0: b.n0, n1: b.n1, g0: b.g0, g1: b.g1 });
    }

    function renderMTO(colour, lead) {
      var host = $('alb-res-mto');
      if (!host) return;
      var m = mtoBand(colour);
      if (!m) {
        Q.mto = null;
        host.innerHTML = '<div class="mto"><span class="mto-l">' + esc(S.builtLabel || '') + '</span>' +
          '<p class="mto-p">' + fill(S.beyond, { neck: Q.neck, chest: Q.chest }) + '</p></div>';
        if (nextBtn) nextBtn.textContent = tLabel('close', 'Close');
        return;
      }
      Q.mto = mtoLink(m.band);
      var rowsHtml =
        '<li>' + esc(S.mtoLabelBand || 'Band') + ' <b>' + esc(bandLabel(m.band)) + '</b></li>' +
        '<li>' + esc(S.mtoRowPrice || 'Price') + ' <b>' + esc(m.band.price) + '</b></li>';
      if (S.mtoRowMade) {
        rowsHtml += '<li>' + esc(S.mtoLabelMade || 'Made') + ' <b>' + esc(S.mtoRowMade) + '</b></li>';
      }
      var why = m.exact ? (S.mtoWhyExact || '') : (S.mtoWhyGirth || '');
      host.innerHTML = '<div class="mto"><span class="mto-l">' + esc(S.mtoEyebrow || '') + '</span>' +
        '<h4 class="mto-h">' + lead + '</h4>' +
        '<p class="mto-p">' + esc(why) + '</p>' +
        '<ul class="mto-spec">' + rowsHtml + '</ul>' +
        '<a class="btn-mto" href="' + esc(Q.mto) + '">' +
        esc(fill(S.mtoBtn, { colour: m.band.colour || colour })) + '</a>' +
        (S.mtoFine ? '<p class="mto-fine">' + esc(S.mtoFine) + '</p>' : '') + '</div>';
      if (nextBtn) nextBtn.textContent = tLabel('mto', 'Customize this harness');
    }

    var colourHost = $('alb-res-colours');
    function buildResColours(active) {
      if (!colourHost) return;
      colourHost.innerHTML = '';
      colours.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = c === active ? 'on' : '';
        b.setAttribute('data-c', c);
        b.innerHTML = '<i style="background:' + swatchFor(c) + '"></i> ' + esc(c);
        b.addEventListener('click', function () { Q.colour = c; renderResult(); });
        colourHost.appendChild(b);
      });
    }

    function renderResult() {
      var colour = Q.colour || state.colour;
      Q.colour = colour;
      buildResColours(colour);
      Q.mto = null;
      var mtoHost = $('alb-res-mto');
      if (mtoHost) mtoHost.innerHTML = '';

      var res = fit(colour);
      var why = $('alb-res-why'), alt = $('alb-res-alt'), card = $('alb-res-card');
      if (why) why.innerHTML = '';
      if (alt) alt.innerHTML = '';

      var others = colours.filter(function (c) { return c !== colour; });
      var otherName = others[0] || '';
      var ores = otherName ? fit(otherName) : { ok: false };

      var setTxt = function (id, v) { var el = $(id); if (el) el.textContent = v; };
      var setHtml = function (id, v) { var el = $(id); if (el) el.innerHTML = v; };

      if (!res.ok) {
        Q.pick = null;
        if (card) card.classList.add('warnborder');
        setTxt('alb-res-adj', fill(S.sizeFmt, { neck: Q.neck, chest: Q.chest }));
        setTxt('alb-res-price', '');

        if (res.why === 'stock') {
          setTxt('alb-res-eyebrow', S.soldOut || '');
          setHtml('alb-res-h', esc(S.stockHeading || ''));
          setTxt('alb-res-sub', fill(S.stockSub, { size: lbl(res.want.neck, res.want.chest), colour: colour }));
          setTxt('alb-res-size', lbl(res.want.neck, res.want.chest));
          if (why) {
            why.innerHTML = '<li>' + tick() + '<span>' + esc(fill(S.whyChest, { chest: Q.chest, lo: res.want.lo, hi: res.want.hi })) + '</span></li>' +
              '<li>' + tick() + '<span>' + esc(fill(S.whyNeck, { neck: res.want.neck, dog: Q.neck })) + '</span></li>';
          }
          if (ores.ok && alt) {
            alt.innerHTML = '<button type="button" data-jump="' + esc(otherName) + '">' +
              esc(fill(S.altOther, { colour: otherName, size: lbl(ores.hit.neck, ores.hit.chest) })) + '</button>';
          }
          renderMTO(colour, esc(S.mtoLeadStock || ''));
          return;
        }

        if (res.why === 'neck') {
          setTxt('alb-res-eyebrow', S.builtLabel || '');
          setHtml('alb-res-h', esc(S.neckHeading || ''));
          setTxt('alb-res-sub', fill(S.neckSub, { neck: Q.neck }));
          setTxt('alb-res-size', S.builtLabel || '');
          if (why) why.innerHTML = '<li>' + tick() + '<span>' + esc(S.whyNeckMax || '') + '</span></li>';
          renderMTO(colour, esc(S.mtoLeadFit || ''));
          return;
        }

        var nr = nearest(colour);
        setTxt('alb-res-eyebrow', S.builtLabel || '');
        setHtml('alb-res-h', esc(S.gapHeading || ''));
        setTxt('alb-res-sub', S.gapSub || '');
        setTxt('alb-res-size', S.builtLabel || '');
        if (why && nr) {
          why.innerHTML = '<li>' + tick() + '<span>' +
            esc(fill(S.whyChest, { chest: Q.chest, lo: nr.r.lo, hi: nr.r.hi })) + '</span></li>';
        }
        renderMTO(colour, esc(S.mtoLeadFit || ''));
        return;
      }

      var hit = res.hit;
      Q.pick = hit;
      if (card) card.classList.remove('warnborder');
      setTxt('alb-res-eyebrow', S.resEyebrow || '');
      setTxt('alb-res-size', lbl(hit.neck, hit.chest));
      setTxt('alb-res-price', hit.price);
      setTxt('alb-res-adj', adjLbl(hit) + ' · ' + Q.chest + '″');
      setTxt('alb-res-sub', fill(S.resSub, { colour: colour }));

      var lines = [];
      lines.push(fill(S.whyChest, { chest: Q.chest, lo: hit.lo, hi: hit.hi }));
      lines.push(fill(S.whyNeck, { neck: hit.neck, dog: Q.neck }));
      if (Q.coat === 'long' && S.whyCoat) lines.push(S.whyCoat);
      if (Q.grow === 'yes' && S.whyGrow) lines.push(S.whyGrow);
      if (S.whyExchange) lines.push(S.whyExchange);
      if (why) {
        why.innerHTML = lines.map(function (t) {
          return '<li>' + tick() + '<span>' + esc(t) + '</span></li>';
        }).join('');
      }
      if (alt) {
        if (!ores.ok && otherName) alt.innerHTML = esc(fill(S.altNone, { colour: otherName }));
        else if (ores.ok && (ores.hit.neck !== hit.neck || ores.hit.chest !== hit.chest)) {
          alt.innerHTML = esc(fill(S.altOther, { colour: otherName, size: lbl(ores.hit.neck, ores.hit.chest) }));
        }
      }
      var mb = mtoBand(colour);
      if (mtoHost && S.mtoCross) {
        mtoHost.innerHTML = '<p class="mtoline">' + esc(S.mtoCross) +
          ' <a href="' + esc(mtoLink(mb && mb.band)) + '">' + esc(S.mtoBtn ? fill(S.mtoBtn, { colour: colour }) : '') + '</a></p>';
      }
      if (nextBtn) nextBtn.textContent = tLabel('use', 'Use this size');
    }

    var altHost = $('alb-res-alt');
    if (altHost) {
      altHost.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('button[data-jump]') : null;
        if (!b) return;
        Q.colour = b.getAttribute('data-jump');
        renderResult();
      });
    }

    function validate(n) {
      if (n === 2) {
        var el = $('alb-in-neck'), v = parseFloat(el ? el.value : NaN);
        var ok = v >= 4 && v <= 40;
        var f = $('alb-f-neck'), er = $('alb-e-neck');
        if (f) f.classList.toggle('bad', !ok);
        if (er) er.classList.toggle('on', !ok);
        if (ok) Q.neck = v;
        return ok;
      }
      if (n === 3) {
        var el2 = $('alb-in-chest'), c = parseFloat(el2 ? el2.value : NaN);
        var ok2 = c >= 6 && c <= 60;
        var f2 = $('alb-f-chest'), er2 = $('alb-e-chest');
        if (f2) f2.classList.toggle('bad', !ok2);
        if (er2) er2.classList.toggle('on', !ok2);
        if (ok2) Q.chest = c;
        return ok2;
      }
      return true;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (Q.step === 5) {
          if (Q.pick) {
            state.colour = Q.pick.colour;
            state.neck = Q.pick.neck;
            state.chest = Q.pick.chest;
            if (Q.pick.image) setImage(Q.pick.image, Q.pick.colour);
            refresh();
            closeQuiz();
            var box = $('alb-buybox');
            if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
            var tip = $('alb-tip'), tipT = $('alb-tip-t');
            if (tip && tipT && S.tipSet) {
              tip.classList.add('set');
              tipT.textContent = fill(S.tipSet, {
                size: lbl(Q.pick.neck, Q.pick.chest), lo: Q.pick.lo, hi: Q.pick.hi, chest: Q.chest
              });
            }
            toast(fill(S.sizeSetToast, { size: lbl(Q.pick.neck, Q.pick.chest) }));
          } else if (Q.mto) {
            window.open(Q.mto, '_blank', 'noopener');
          } else {
            closeQuiz();
          }
          return;
        }
        if (!validate(Q.step)) return;
        if (Q.step === 4) { Q.colour = state.colour; renderResult(); }
        showStep(Q.step + 1);
      });
    }
    var qback = $('alb-qback');
    if (qback) qback.addEventListener('click', function () { if (Q.step > 1) showStep(Q.step - 1); });
    ['alb-in-neck', 'alb-in-chest'].forEach(function (id) {
      var el = $(id);
      if (!el) return;
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); if (nextBtn) nextBtn.click(); }
      });
      el.addEventListener('input', function () {
        var f = $(id === 'alb-in-neck' ? 'alb-f-neck' : 'alb-f-chest');
        var er = $(id === 'alb-in-neck' ? 'alb-e-neck' : 'alb-e-chest');
        if (f) f.classList.remove('bad');
        if (er) er.classList.remove('on');
      });
    });

    showStep(1);
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arhus-lp-v2"]) return;
  try {
    
(function () {
  function init() {
    var root = document.getElementById('arh2-root');
    if (!root) return;

    var T_ADD = root.getAttribute('data-t-add') || 'Add to cart';
    var T_SOLD = root.getAttribute('data-t-sold') || 'Sold out';

    var dataEl = root.querySelector('#arh2-variants');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }
    if (!variants.length) return;

    /* ---- money ---- */
    var fmt = root.getAttribute('data-money-format') || '${{amount}}';
    function money(cents) {
      function pad(n, d) { n = String(n); while (n.length < d) n = '0' + n; return n; }
      function commas(n) { return n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'); }
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
        var v = Math.abs(cents) / 100, whole = Math.floor(v);
        var dec = pad(Math.round((v - whole) * 100), 2);
        switch (name) {
          case 'amount': return commas(String(whole)) + '.' + dec;
          case 'amount_no_decimals': return commas(String(Math.round(v)));
          case 'amount_with_comma_separator': return commas(String(whole)).replace(/,/g, '.') + ',' + dec;
          case 'amount_no_decimals_with_comma_separator': return commas(String(Math.round(v))).replace(/,/g, '.');
          case 'amount_with_apostrophe_separator': return commas(String(whole)).replace(/,/g, "'") + '.' + dec;
          default: return commas(String(whole)) + '.' + dec;
        }
      });
    }

    var lensHost = root.querySelector('#arh2-lens');
    var lenSet = lensHost ? lensHost.closest('.arh2-optset') : null;
    var sizeIdx = lenSet ? parseInt(lenSet.getAttribute('data-option-index'), 10) : -1;
    var colorSet = root.querySelector('.arh2-optset[data-is-color="true"]');
    var colorIdx = colorSet ? parseInt(colorSet.getAttribute('data-option-index'), 10) : -1;
    var segHost = root.querySelector('#arh2-segs');

    var current = variants[0];
    var idInput = root.querySelector('#arh2-variant-id');
    if (idInput) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(idInput.value)) { current = variants[i]; break; }
      }
    }
    var sel = current.options.slice();
    var qty = 1;

    function parseSize(v) {
      var m = String(v).match(/^\s*([\d.\/]+)\s*"?\s*Length\s*X\s*([\d.\/]+)\s*"?\s*Width\s*$/i);
      if (m) return { len: m[1], width: m[2] };
      return { len: String(v), width: '' };
    }
    function allSizes() {
      var seen = {}, out = [];
      variants.forEach(function (v) {
        var s = v.options[sizeIdx];
        if (s != null && !seen[s]) { seen[s] = 1; out.push(s); }
      });
      return out;
    }
    function widths() {
      var seen = {}, out = [];
      allSizes().forEach(function (s) {
        var w = parseSize(s).width;
        if (!seen[w]) { seen[w] = 1; out.push(w); }
      });
      return out;
    }
    function sizesForWidth(w) {
      return allSizes().filter(function (s) { return parseSize(s).width === w; });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function variantForSize(s) {
      var t = sel.slice(); t[sizeIdx] = s; return findVariant(t);
    }
    function priceForSize(s) {
      var v = variantForSize(s);
      if (v) return v.price;
      for (var i = 0; i < variants.length; i++) { if (variants[i].options[sizeIdx] === s) return variants[i].price; }
      return '';
    }

    var curWidth = sizeIdx > -1 ? parseSize(sel[sizeIdx]).width : '';

    function buildSegs() {
      if (!segHost) return;
      var ws = widths();
      segHost.innerHTML = '';
      if (ws.length < 2) { var wo = root.querySelector('#arh2-width-opt'); if (wo) wo.style.display = 'none'; return; }
      ws.forEach(function (w) {
        var list = sizesForWidth(w);
        var lo = list[0], hi = list[list.length - 1];
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'seg' + (w === curWidth ? ' on' : '');
        var loL = parseSize(lo).len, hiL = parseSize(hi).len;
        var range = loL === hiL ? loL + '″' : loL + '–' + hiL + '″';
        b.innerHTML = '<span class="a">' + w + '″</span><span class="b">' + range + '</span>';
        b.addEventListener('click', function () {
          curWidth = w;
          var options = sizesForWidth(w);
          var keep = null;
          for (var i = 0; i < options.length; i++) { if (variantForSize(options[i]) && variantForSize(options[i]).available) { keep = options[i]; break; } }
          if (keep) pick(sizeIdx, keep); else { render(); }
        });
        segHost.appendChild(b);
      });
    }

    function buildLens() {
      if (!lensHost) return;
      lensHost.innerHTML = '';
      sizesForWidth(curWidth).forEach(function (s) {
        var v = variantForSize(s);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'len' + (sel[sizeIdx] === s ? ' on' : '');
        b.disabled = !(v && v.available);
        if (b.disabled) b.title = 'Sold out in this colour';
        b.innerHTML = '<span class="a">' + parseSize(s).len + '″</span><span class="b">' + priceForSize(s) + '</span>';
        b.addEventListener('click', function () { pick(sizeIdx, s); });
        lensHost.appendChild(b);
      });
    }

    var stickSel = root.querySelector('#arh2-stick-sel');
    function buildSelect() {
      if (!stickSel) return;
      stickSel.innerHTML = '';
      allSizes().forEach(function (s) {
        var p = parseSize(s), v = variantForSize(s);
        var o = document.createElement('option');
        o.value = s;
        o.textContent = p.len + '″ × ' + p.width + '″ — ' + priceForSize(s);
        o.disabled = !(v && v.available);
        stickSel.appendChild(o);
      });
      stickSel.value = sel[sizeIdx];
    }
    if (stickSel) stickSel.addEventListener('change', function () { if (this.value) pick(sizeIdx, this.value); });

    function pick(idx, value) {
      if (idx < 0) return;
      sel[idx] = value;
      if (idx === sizeIdx) curWidth = parseSize(value).width;
      var v = findVariant(sel);
      if ((!v || !v.available) && colorIdx > -1 && idx === sizeIdx) {
        var sws = colorSet.querySelectorAll('.sw');
        for (var i = 0; i < sws.length; i++) {
          var t = sel.slice(); t[colorIdx] = sws[i].getAttribute('data-c');
          var cand = findVariant(t);
          if (cand && cand.available) { sel = t; break; }
        }
      }
      render();
    }

    function render() {
      current = findVariant(sel);

      if (colorSet) {
        colorSet.querySelectorAll('.sw').forEach(function (s) {
          var val = s.getAttribute('data-c');
          var on = val === sel[colorIdx];
          s.classList.toggle('on', on);
          s.setAttribute('aria-checked', on ? 'true' : 'false');
          var t = sel.slice(); t[colorIdx] = val;
          var cand = findVariant(t);
          if (cand && !cand.available) s.setAttribute('data-out', '1'); else s.removeAttribute('data-out');
        });
        var cl = root.querySelector('#arh2-color-label');
        if (cl) cl.textContent = sel[colorIdx];
      }
      buildSegs(); buildLens(); buildSelect();

      var unit = current ? current.raw : 0;
      var ok = !!(current && current.available);

      var pEl = root.querySelector('#arh2-price');
      if (pEl && current) pEl.textContent = current.price;
      var sub = root.querySelector('#arh2-price-sub');
      if (sub && sizeIdx > -1) {
        var p = parseSize(sel[sizeIdx]);
        sub.textContent = p.len + '″ × ' + p.width + '″';
      }
      var meta = root.querySelector('#arh2-stick-meta');
      if (meta) meta.textContent = (colorIdx > -1 ? sel[colorIdx] : '');
      var fp = root.querySelector('#arh2-final-price');
      if (fp && current) fp.textContent = current.price + (sizeIdx > -1 ? ' · ' + parseSize(sel[sizeIdx]).len + '″' : '');

      if (idInput && current) idInput.value = current.id;
      var qIn = root.querySelector('#arh2-qty-input');
      if (qIn) qIn.value = qty;
      var qn = root.querySelector('#arh2-qn');
      if (qn) qn.textContent = qty;

      var total = ok ? money(unit * qty) : '';
      var atc = root.querySelector('#arh2-atc');
      if (atc) { atc.disabled = !ok; atc.textContent = ok ? T_ADD + ' — ' + total : T_SOLD; }
      var sb = root.querySelector('#arh2-stick-btn');
      if (sb) { sb.disabled = !ok; sb.textContent = ok ? T_ADD + ' — ' + total : T_SOLD; }
      var fb = root.querySelector('#arh2-final-btn');
      if (fb) { fb.disabled = !ok; fb.textContent = ok ? T_ADD + ' — ' + total : T_SOLD; }

      if (current && current.image) setImage(current.image);
      root.querySelectorAll('.arh2-row-price').forEach(function (td) {
        var real = resolveSize(td.getAttribute('data-size-value'));
        td.textContent = real ? priceForSize(real) : '';
      });
    }

    /* The badge overlays the top-left of the main image. Several gallery images are
       marketing graphics with their own headline in that exact spot, so the badge is
       shown only while the image the gallery opened on is displayed. */
    /* Variant option values are merchant-entered and can carry stray whitespace
       (the 16-inch size on this product has a double space). Match them loosely so a
       typo in Shopify cannot break the sizing table or disable the buy box. */
    function normSize(v) { return String(v).replace(/\s+/g, ' ').trim().toLowerCase(); }
    function resolveSize(want) {
      var all = allSizes(), w = normSize(want);
      for (var i = 0; i < all.length; i++) { if (normSize(all[i]) === w) return all[i]; }
      return null;
    }

    var defaultImg = null;
    var badgeEl = root.querySelector('.tagpill');
    function syncBadge(url) {
      if (!badgeEl || !defaultImg) return;
      badgeEl.classList.toggle('is-hidden', url !== defaultImg);
    }

    function setImage(url) {
      var main = root.querySelector('#arh2-main-img');
      if (!url || !main || main.getAttribute('src') === url) return;
      main.style.opacity = '0';
      setTimeout(function () { main.src = url; main.style.opacity = '1'; }, 130);
      var st = root.querySelector('#arh2-stick-img');
      if (st) st.src = url;
      syncBadge(url);
      root.querySelectorAll('.th').forEach(function (t) {
        t.classList.toggle('on', t.getAttribute('data-f') === url);
      });
    }
    root.querySelectorAll('.th').forEach(function (t) {
      t.addEventListener('click', function () { setImage(t.getAttribute('data-f')); });
    });
    if (colorSet) {
      colorSet.querySelectorAll('.sw').forEach(function (s) {
        s.addEventListener('click', function () { pick(colorIdx, s.getAttribute('data-c')); });
      });
    }
    var FIT_LEAD = 'We recommend';
    var FIT_OOS = 'sold out in this colour';
    var FIT_TOOBIG = 'That is larger than our longest collar ({max}). Message us and we will help.';
    /* ---- swipe the main image on touch devices ---- */
    var galWrap = root.querySelector('.gal-main');
    if (galWrap) {
      var sX = 0, sY = 0, swiping = false;
      galWrap.addEventListener('touchstart', function (e) {
        sX = e.touches[0].clientX; sY = e.touches[0].clientY; swiping = true;
      }, { passive: true });
      galWrap.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var dx = e.changedTouches[0].clientX - sX, dy = e.changedTouches[0].clientY - sY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;   // a tap, or a vertical scroll
        var ths = Array.prototype.slice.call(root.querySelectorAll('.th'));
        if (ths.length < 2) return;
        var main = root.querySelector('#arh2-main-img');
        var cur = main ? main.getAttribute('src') : null, idx = -1;
        for (var i = 0; i < ths.length; i++) { if (ths[i].getAttribute('data-f') === cur) { idx = i; break; } }
        if (idx < 0) idx = 0;
        var next = (idx + (dx < 0 ? 1 : -1) + ths.length) % ths.length;
        setImage(ths[next].getAttribute('data-f'));
        if (ths[next].scrollIntoView) ths[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }, { passive: true });
    }

    /* ---- fit finder ---- */
    var fit = root.querySelector('#arh2-fit');
    if (fit) {
      var fitIn = root.querySelector('#arh2-fit-in');
      var fitSnug = root.querySelector('#arh2-fit-snug');
      var fitRes = root.querySelector('#arh2-fit-result');
      var fitApply = root.querySelector('#arh2-fit-apply');
      var fitUnit = 'in';
      var suggestion = null;
      var lastTrigger = null;

      function openFit(e) {
        lastTrigger = e && e.currentTarget ? e.currentTarget : null;
        fit.hidden = false;
        document.body.style.overflow = 'hidden';
        setTimeout(function () { if (fitIn) fitIn.focus(); }, 30);
      }
      function closeFit() {
        fit.hidden = true;
        document.body.style.overflow = '';
        if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
      }
      root.querySelectorAll('[data-fitopen]').forEach(function (b) {
        b.addEventListener('click', function (ev) { ev.preventDefault(); openFit(ev); });
      });
      fit.querySelectorAll('[data-fitclose]').forEach(function (b) {
        b.addEventListener('click', closeFit);
      });
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && !fit.hidden) closeFit();
        if (ev.key === 'Tab' && !fit.hidden) {
          var f = fit.querySelectorAll('button, input, [href], select, textarea');
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
          else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
        }
      });

      fit.querySelectorAll('.fit-unit').forEach(function (u) {
        u.addEventListener('click', function () {
          fitUnit = u.getAttribute('data-unit');
          fit.querySelectorAll('.fit-unit').forEach(function (x) {
            var on = x === u;
            x.classList.toggle('on', on);
            x.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          compute();
        });
      });

      function compute() {
        var raw = parseFloat(fitIn && fitIn.value);
        suggestion = null;
        if (fitApply) fitApply.hidden = true;
        if (!raw || raw <= 0) { if (fitRes) fitRes.innerHTML = ''; return; }
        var inches = fitUnit === 'cm' ? raw / 2.54 : raw;
        if (fitSnug && fitSnug.checked) inches += 1.25;   // two finger widths

        // candidate lengths from the live variants, smallest that still clears the neck
        var cands = [];
        allSizes().forEach(function (s) {
          var len = parseFloat(parseSize(s).len);
          if (!isNaN(len)) cands.push({ len: len, size: s, v: variantForSize(s) });
        });
        cands.sort(function (a, b) { return a.len - b.len || (b.v && b.v.available ? 1 : -1); });
        var fits = cands.filter(function (c) { return c.len >= inches - 0.001; });
        var pickC = fits.filter(function (c) { return c.v && c.v.available; })[0] || fits[0];
        var biggest = cands[cands.length - 1];

        if (!fits.length) {
          fitRes.innerHTML = '<span class="fit-warn">' + FIT_TOOBIG.replace('{max}', biggest ? biggest.len + '\u2033' : '') + '</span>';
          return;
        }
        suggestion = pickC;
        var p = parseSize(pickC.size);
        var note = pickC.v && pickC.v.available ? '' : ' <span class="fit-warn">' + FIT_OOS + '</span>';
        fitRes.innerHTML = '<span class="fit-lead">' + FIT_LEAD + '</span>' +
          '<strong class="fit-size">' + p.len + '\u2033' + (p.width ? ' \u00d7 ' + p.width + '\u2033' : '') + '</strong>' +
          '<span class="fit-sub">' + (pickC.v ? pickC.v.price : '') + note + '</span>';
        if (fitApply) fitApply.hidden = false;
      }

      if (fitIn) fitIn.addEventListener('input', compute);
      if (fitSnug) fitSnug.addEventListener('change', compute);
      if (fitApply) fitApply.addEventListener('click', function () {
        if (!suggestion) return;
        pick(sizeIdx, suggestion.size);
        closeFit();
        var box = root.querySelector('#arh2-buybox');
        if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    root.querySelectorAll('.mini').forEach(function (m) {
      m.addEventListener('click', function () {
        var real = resolveSize(m.getAttribute('data-pick'));
        if (!real) return;                  // row does not map to a live variant
        pick(sizeIdx, real);
        var box = root.querySelector('#arh2-buybox');
        if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    var minus = root.querySelector('#arh2-minus'), plus = root.querySelector('#arh2-plus');
    if (minus) minus.addEventListener('click', function () { if (qty > 1) { qty--; render(); } });
    if (plus) plus.addEventListener('click', function () { if (qty < 10) { qty++; render(); } });

    var form = root.querySelector('#arh2-form') || root.querySelector('form[action*="/cart/add"]');
    function submitForm() {
      if (!current || !current.available) return;
      if (form && typeof form.requestSubmit === 'function') form.requestSubmit();
      else if (form) form.submit();
    }
    ['#arh2-stick-btn', '#arh2-final-btn'].forEach(function (id) {
      var b = root.querySelector(id);
      if (b) b.addEventListener('click', submitForm);
    });

    var stick = root.querySelector('#arh2-stick');
    var atcBtn = root.querySelector('#arh2-atc');
    if (stick && atcBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        stick.classList.toggle('on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(atcBtn);
    }

    /* ---- workshop video: play only in view, respect reduced motion ---- */
    var film = root.querySelector('#arh2-film');
    if (film) {
      var noMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      film.muted = true;               // property, not just the attribute — WebKit needs both
      if (noMotion) {
        film.removeAttribute('autoplay');
        film.pause();
        film.setAttribute('controls', 'controls');
      } else if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) {
              var pr = film.play();
              // if the browser refuses (iOS Low Power Mode, data saver), give the user a way to start it
              if (pr && pr.catch) pr.catch(function () { film.setAttribute('controls', 'controls'); });
            } else if (!film.paused) {
              film.pause();
            }
          });
        }, { threshold: 0.25 }).observe(film);
      }
    }

    root.querySelectorAll('.fq > button').forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.parentNode.classList.toggle('open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    render();

    /* whatever is on screen once the first render settles is the 'default' view */
    (function () {
      var m = root.querySelector('#arh2-main-img');
      if (m) { defaultImg = m.getAttribute('src'); syncBadge(defaultImg); }
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arhus-lp"]) return;
  try {
    
(function () {
  function init() {
    var root = document.getElementById('arh-root');
    if (!root) return;

    var T_ADD = root.getAttribute('data-t-add') || 'Add to cart';
    var T_SOLD = root.getAttribute('data-t-sold') || 'Sold out';

    var dataEl = root.querySelector('#arh-variants');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }
    if (!variants.length) return;

    var sizeHost = root.querySelector('#arh-sizes');
    var sizeSet = sizeHost ? sizeHost.closest('.arh-optset') || sizeHost : null;
    var sizeIdx = sizeHost ? parseInt(sizeHost.getAttribute('data-option-index'), 10) : -1;
    var colorSet = root.querySelector('.arh-optset[data-is-color="true"]');
    var colorIdx = colorSet ? parseInt(colorSet.getAttribute('data-option-index'), 10) : -1;

    // Current selection, seeded from the variant Liquid rendered.
    var current = variants[0];
    var idInput = root.querySelector('#arh-variant-id');
    if (idInput) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(idInput.value)) { current = variants[i]; break; }
      }
    }
    var sel = current.options.slice();

    /* ---- parse "20\" Length X 2/5\" Width" into {len, width} ---- */
    function parseSize(v) {
      var m = String(v).match(/^\s*([\d.\/]+)\s*"?\s*Length\s*X\s*([\d.\/]+)\s*"?\s*Width\s*$/i);
      if (m) return { len: m[1], width: m[2], label: m[1] + '″', sub: m[2] + '″ thick' };
      return { len: String(v), width: '', label: String(v), sub: '' };
    }
    function sizeValues() {
      var seen = {}, out = [];
      variants.forEach(function (v) {
        var s = v.options[sizeIdx];
        if (s != null && !seen[s]) { seen[s] = 1; out.push(s); }
      });
      return out;
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function availableFor(sizeVal) {
      var test = sel.slice();
      if (sizeIdx > -1) test[sizeIdx] = sizeVal;
      var v = findVariant(test);
      return v && v.available;
    }
    function priceFor(sizeVal) {
      var test = sel.slice();
      if (sizeIdx > -1) test[sizeIdx] = sizeVal;
      var v = findVariant(test);
      if (v) return v.price;
      // fall back to any variant with this size, so the table still shows a price
      for (var i = 0; i < variants.length; i++) { if (variants[i].options[sizeIdx] === sizeVal) return variants[i].price; }
      return '';
    }

    /* ---- build the size buttons, grouped by roll width ---- */
    function buildSizes() {
      if (!sizeHost) return;
      var groups = [], byWidth = {};
      sizeValues().forEach(function (val) {
        var p = parseSize(val);
        if (!byWidth[p.width]) { byWidth[p.width] = []; groups.push(p.width); }
        byWidth[p.width].push({ val: val, p: p });
      });
      sizeHost.innerHTML = '';
      groups.forEach(function (w) {
        var g = document.createElement('div');
        g.className = 'size-group';
        if (groups.length > 1 && w) {
          var h = document.createElement('div');
          h.className = 'size-group-h';
          h.innerHTML = '<span>' + w + '″ Thick</span>';
          g.appendChild(h);
        }
        var grid = document.createElement('div');
        grid.className = 'size-grid';
        byWidth[w].forEach(function (item) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'size-btn' + (sel[sizeIdx] === item.val ? ' active' : '');
          b.setAttribute('data-value', item.val);
          b.disabled = !availableFor(item.val);
          if (b.disabled) b.title = 'Sold out in this colour';
          b.innerHTML = '<span class="len">' + item.p.label + '</span><span class="wid">' + priceFor(item.val) + '</span>';
          b.addEventListener('click', function () { pick(sizeIdx, item.val); });
          grid.appendChild(b);
        });
        g.appendChild(grid);
        sizeHost.appendChild(g);
      });
    }

    /* ---- sticky size select ---- */
    var stickySel = root.querySelector('#arh-sticky-size');
    function buildSelect() {
      if (!stickySel) return;
      stickySel.innerHTML = '';
      sizeValues().forEach(function (val) {
        var p = parseSize(val);
        var o = document.createElement('option');
        o.value = val;
        o.textContent = p.label + (p.sub ? ' · ' + p.sub : '') + ' — ' + priceFor(val);
        o.disabled = !availableFor(val);
        stickySel.appendChild(o);
      });
      stickySel.value = sel[sizeIdx];
    }
    if (stickySel) {
      stickySel.addEventListener('change', function () { if (this.value) pick(sizeIdx, this.value); });
    }

    /* ---- selection ---- */
    function pick(idx, value) {
      if (idx < 0) return;
      sel[idx] = value;
      var v = findVariant(sel);
      // if this combination doesn't exist or is out of stock, move to an available colour
      if ((!v || !v.available) && colorIdx > -1 && idx === sizeIdx) {
        var swatches = colorSet.querySelectorAll('.sw');
        for (var i = 0; i < swatches.length; i++) {
          var test = sel.slice();
          test[colorIdx] = swatches[i].getAttribute('data-value');
          var cand = findVariant(test);
          if (cand && cand.available) { sel = test; v = cand; break; }
        }
      }
      apply(v);
    }

    function apply(v) {
      current = v || findVariant(sel);
      // swatches
      if (colorSet) {
        colorSet.querySelectorAll('.sw').forEach(function (s) {
          var val = s.getAttribute('data-value');
          var on = val === sel[colorIdx];
          s.classList.toggle('active', on);
          s.setAttribute('aria-checked', on ? 'true' : 'false');
          var test = sel.slice(); test[colorIdx] = val;
          var cand = findVariant(test);
          if (cand && !cand.available) s.setAttribute('data-oos', '1'); else s.removeAttribute('data-oos');
        });
        var cl = root.querySelector('#arh-color-label');
        if (cl) cl.textContent = sel[colorIdx];
      }
      buildSizes();
      buildSelect();

      var priceTxt = current ? current.price : '';
      ['#arh-price', '#arh-sticky-price', '#arh-final-price'].forEach(function (id) {
        var el = root.querySelector(id);
        if (el && priceTxt) el.textContent = priceTxt;
      });
      var note = root.querySelector('#arh-price-note');
      if (note && sizeIdx > -1) {
        var p = parseSize(sel[sizeIdx]);
        note.textContent = p.label + (p.sub ? ' · ' + p.sub : '');
      }
      var meta = root.querySelector('#arh-sticky-meta');
      if (meta && colorIdx > -1) meta.textContent = sel[colorIdx];

      if (idInput && current) idInput.value = current.id;

      var atc = root.querySelector('#arh-atc');
      if (atc) {
        var ok = current && current.available;
        atc.disabled = !ok;
        atc.textContent = ok ? T_ADD : T_SOLD;
      }
      var sbtn = root.querySelector('#arh-sticky-btn');
      if (sbtn) sbtn.textContent = current && current.available ? T_ADD : T_SOLD;

      if (current && current.image) setImage(current.image);
      updateTablePrices();
    }

    /* ---- gallery ---- */
    /* The badge overlays the top-left of the main image. Several gallery images are
       marketing graphics with their own headline in that exact spot, so the badge is
       shown only while the image the gallery opened on is displayed. */
    /* Variant option values are merchant-entered and can carry stray whitespace
       (the 16-inch size on this product has a double space). Match them loosely so a
       typo in Shopify cannot break the sizing table or disable the buy box. */
    function normSize(v) { return String(v).replace(/\s+/g, ' ').trim().toLowerCase(); }
    function resolveSize(want) {
      var all = allSizes(), w = normSize(want);
      for (var i = 0; i < all.length; i++) { if (normSize(all[i]) === w) return all[i]; }
      return null;
    }

    var defaultImg = null;
    var badgeEl = root.querySelector('.hero-badge');
    function syncBadge(url) {
      if (!badgeEl || !defaultImg) return;
      badgeEl.classList.toggle('is-hidden', url !== defaultImg);
    }

    function setImage(url) {
      var main = root.querySelector('#arh-main-img');
      if (!url || !main || main.getAttribute('src') === url) return;
      main.style.opacity = '0';
      setTimeout(function () { main.src = url; main.style.opacity = '1'; }, 120);
      var st = root.querySelector('#arh-sticky-img');
      if (st) st.src = url;
      syncBadge(url);
      root.querySelectorAll('.thumb').forEach(function (t) {
        t.classList.toggle('active', t.getAttribute('data-full') === url);
      });
    }
    root.querySelectorAll('.thumb').forEach(function (t) {
      t.addEventListener('click', function () { setImage(t.getAttribute('data-full')); });
    });

    /* ---- colour swatches ---- */
    if (colorSet) {
      colorSet.querySelectorAll('.sw').forEach(function (s) {
        s.addEventListener('click', function () { pick(colorIdx, s.getAttribute('data-value')); });
      });
    }

    /* v1 names these differently to v2 — bridge them for the fit finder */
    function allSizes() { return sizeValues(); }
    function variantForSize(sv) { var t = sel.slice(); t[sizeIdx] = sv; return findVariant(t); }
    var FIT_LEAD = 'We recommend';
    var FIT_OOS = 'sold out in this colour';
    var FIT_TOOBIG = 'That is larger than our longest collar ({max}). Message us and we will help.';
    /* ---- swipe the main image on touch devices ---- */
    var galWrap = root.querySelector('.hero-main');
    if (galWrap) {
      var sX = 0, sY = 0, swiping = false;
      galWrap.addEventListener('touchstart', function (e) {
        sX = e.touches[0].clientX; sY = e.touches[0].clientY; swiping = true;
      }, { passive: true });
      galWrap.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var dx = e.changedTouches[0].clientX - sX, dy = e.changedTouches[0].clientY - sY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;   // a tap, or a vertical scroll
        var ths = Array.prototype.slice.call(root.querySelectorAll('.thumb'));
        if (ths.length < 2) return;
        var main = root.querySelector('#arh-main-img');
        var cur = main ? main.getAttribute('src') : null, idx = -1;
        for (var i = 0; i < ths.length; i++) { if (ths[i].getAttribute('data-full') === cur) { idx = i; break; } }
        if (idx < 0) idx = 0;
        var next = (idx + (dx < 0 ? 1 : -1) + ths.length) % ths.length;
        setImage(ths[next].getAttribute('data-full'));
        if (ths[next].scrollIntoView) ths[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }, { passive: true });
    }

    /* ---- fit finder ---- */
    var fit = root.querySelector('#arh-fit');
    if (fit) {
      var fitIn = root.querySelector('#arh-fit-in');
      var fitSnug = root.querySelector('#arh-fit-snug');
      var fitRes = root.querySelector('#arh-fit-result');
      var fitApply = root.querySelector('#arh-fit-apply');
      var fitUnit = 'in';
      var suggestion = null;
      var lastTrigger = null;

      function openFit(e) {
        lastTrigger = e && e.currentTarget ? e.currentTarget : null;
        fit.hidden = false;
        document.body.style.overflow = 'hidden';
        setTimeout(function () { if (fitIn) fitIn.focus(); }, 30);
      }
      function closeFit() {
        fit.hidden = true;
        document.body.style.overflow = '';
        if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
      }
      root.querySelectorAll('[data-fitopen]').forEach(function (b) {
        b.addEventListener('click', function (ev) { ev.preventDefault(); openFit(ev); });
      });
      fit.querySelectorAll('[data-fitclose]').forEach(function (b) {
        b.addEventListener('click', closeFit);
      });
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && !fit.hidden) closeFit();
        if (ev.key === 'Tab' && !fit.hidden) {
          var f = fit.querySelectorAll('button, input, [href], select, textarea');
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
          else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
        }
      });

      fit.querySelectorAll('.fit-unit').forEach(function (u) {
        u.addEventListener('click', function () {
          fitUnit = u.getAttribute('data-unit');
          fit.querySelectorAll('.fit-unit').forEach(function (x) {
            var on = x === u;
            x.classList.toggle('on', on);
            x.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          compute();
        });
      });

      function compute() {
        var raw = parseFloat(fitIn && fitIn.value);
        suggestion = null;
        if (fitApply) fitApply.hidden = true;
        if (!raw || raw <= 0) { if (fitRes) fitRes.innerHTML = ''; return; }
        var inches = fitUnit === 'cm' ? raw / 2.54 : raw;
        if (fitSnug && fitSnug.checked) inches += 1.25;   // two finger widths

        // candidate lengths from the live variants, smallest that still clears the neck
        var cands = [];
        allSizes().forEach(function (s) {
          var len = parseFloat(parseSize(s).len);
          if (!isNaN(len)) cands.push({ len: len, size: s, v: variantForSize(s) });
        });
        cands.sort(function (a, b) { return a.len - b.len || (b.v && b.v.available ? 1 : -1); });
        var fits = cands.filter(function (c) { return c.len >= inches - 0.001; });
        var pickC = fits.filter(function (c) { return c.v && c.v.available; })[0] || fits[0];
        var biggest = cands[cands.length - 1];

        if (!fits.length) {
          fitRes.innerHTML = '<span class="fit-warn">' + FIT_TOOBIG.replace('{max}', biggest ? biggest.len + '\u2033' : '') + '</span>';
          return;
        }
        suggestion = pickC;
        var p = parseSize(pickC.size);
        var note = pickC.v && pickC.v.available ? '' : ' <span class="fit-warn">' + FIT_OOS + '</span>';
        fitRes.innerHTML = '<span class="fit-lead">' + FIT_LEAD + '</span>' +
          '<strong class="fit-size">' + p.len + '\u2033' + (p.width ? ' \u00d7 ' + p.width + '\u2033' : '') + '</strong>' +
          '<span class="fit-sub">' + (pickC.v ? pickC.v.price : '') + note + '</span>';
        if (fitApply) fitApply.hidden = false;
      }

      if (fitIn) fitIn.addEventListener('input', compute);
      if (fitSnug) fitSnug.addEventListener('change', compute);
      if (fitApply) fitApply.addEventListener('click', function () {
        if (!suggestion) return;
        pick(sizeIdx, suggestion.size);
        closeFit();
        var box = root.querySelector('#arh-buybox');
        if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* ---- sizing table ---- */
    function updateTablePrices() {
      root.querySelectorAll('.arh-row-price').forEach(function (td) {
        var real = resolveSize(td.getAttribute('data-size-value'));
        td.textContent = real ? priceFor(real) : '';
      });
    }
    root.querySelectorAll('.pick').forEach(function (p) {
      p.addEventListener('click', function () {
        var real = resolveSize(p.getAttribute('data-pick'));
        if (!real) return;                  // row does not map to a live variant
        pick(sizeIdx, real);
        var box = root.querySelector('#arh-buybox');
        if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* ---- final + sticky buttons submit the real form ---- */
    var form = root.querySelector('#arh-form') || root.querySelector('form[action*="/cart/add"]');
    function submitForm() {
      if (!current || !current.available) return;
      if (form && typeof form.requestSubmit === 'function') form.requestSubmit();
      else if (form) form.submit();
    }
    ['#arh-sticky-btn', '#arh-final-btn'].forEach(function (id) {
      var b = root.querySelector(id);
      if (b) b.addEventListener('click', submitForm);
    });

    /* ---- sticky reveal ---- */
    var sticky = root.querySelector('#arh-sticky');
    var atcBtn = root.querySelector('#arh-atc');
    if (sticky && atcBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        var passed = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        sticky.classList.toggle('on', passed);
      }, { threshold: 0 }).observe(atcBtn);
    }

    /* ---- workshop video: play only in view, respect reduced motion ---- */
    var film = root.querySelector('#arh-film');
    if (film) {
      var noMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      film.muted = true;               // property, not just the attribute — WebKit needs both
      if (noMotion) {
        film.removeAttribute('autoplay');
        film.pause();
        film.setAttribute('controls', 'controls');
      } else if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) {
              var pr = film.play();
              // if the browser refuses (iOS Low Power Mode, data saver), give the user a way to start it
              if (pr && pr.catch) pr.catch(function () { film.setAttribute('controls', 'controls'); });
            } else if (!film.paused) {
              film.pause();
            }
          });
        }, { threshold: 0.25 }).observe(film);
      }
    }

    /* ---- faq ---- */
    root.querySelectorAll('.faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.parentNode;
        var open = item.classList.toggle('open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    apply(current);

    /* whatever is on screen once the first render settles is the 'default' view */
    (function () {
      var m = root.querySelector('#arh-main-img');
      if (m) { defaultImg = m.getAttribute('src'); syncBadge(defaultImg); }
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hund-home-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-hh-faq]').forEach(function (root) {
  if (root.dataset.hhFaqReady) return;
  root.dataset.hhFaqReady = '1';
  root.querySelectorAll('.hh-q-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var wasOpen = item.classList.contains('is-open');
      root.querySelectorAll('.hh-q').forEach(function (q) {
        q.classList.remove('is-open');
        q.querySelector('.hh-q-btn').setAttribute('aria-expanded', 'false');
        q.querySelector('.hh-a').hidden = true;
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        item.querySelector('.hh-a').hidden = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skagen-lp"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var root = document.getElementById('skg-root');
    if (!root) return;

    // Gallery
    function setMainImage(url, isVariant) {
      var main = root.querySelector('#skg-main-img');
      if (!url || !main || main.tagName !== 'IMG') return;
      main.setAttribute('data-current', url);
      if (main.getAttribute('src') !== url) {
        main.style.opacity = '0';
        setTimeout(function () { main.src = url; main.style.opacity = '1'; }, 120);
      }
      if (isVariant) {
        var vt = root.querySelector('#skg-variant-thumb');
        if (vt) {
          vt.setAttribute('data-full', url);
          var vtImg = vt.querySelector('img');
          if (vtImg) vtImg.src = url.replace('width=1400', 'width=240');
        }
      }
      root.querySelectorAll('.thumb').forEach(function (x) {
        x.classList.toggle('active', x.getAttribute('data-full') === url);
      });
    }
    root.querySelectorAll('.thumb').forEach(function (t) {
      t.addEventListener('click', function () { setMainImage(t.getAttribute('data-full'), false); });
    });

    // Swipe on main image (mobile)
    var mainWrap = root.querySelector('.hero-main');
    if (mainWrap) {
      var swipeX = 0, swipeY = 0, swiping = false;
      mainWrap.addEventListener('touchstart', function (e) {
        swipeX = e.touches[0].clientX; swipeY = e.touches[0].clientY; swiping = true;
      }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var dx = e.changedTouches[0].clientX - swipeX;
        var dy = e.changedTouches[0].clientY - swipeY;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return; // ignore taps and vertical scrolls
        var thumbs = Array.prototype.slice.call(root.querySelectorAll('.thumb'));
        var main = root.querySelector('#skg-main-img');
        if (!thumbs.length || !main) return;
        var current = main.getAttribute('data-current') || main.getAttribute('src');
        var cur = -1;
        thumbs.forEach(function (t, i) { if (t.getAttribute('data-full') === current) cur = i; });
        var next = (dx < 0 ? cur + 1 : cur - 1);
        if (next < 0) next = thumbs.length - 1;
        if (next >= thumbs.length) next = 0;
        setMainImage(thumbs[next].getAttribute('data-full'), false);
        if (thumbs[next].scrollIntoView) thumbs[next].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }, { passive: true });
    }

    // Variants
    var dataEl = root.querySelector('#skg-variants');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }
    var idInput = root.querySelector('#skg-variant-id');

    function selectedValues() {
      var sets = Array.prototype.slice.call(root.querySelectorAll('.skg-optset'));
      sets.sort(function (a, b) { return (+a.getAttribute('data-option-index')) - (+b.getAttribute('data-option-index')); });
      return sets.map(function (s) {
        var on = s.querySelector('.on');
        return on ? on.getAttribute('data-value') : null;
      });
    }

    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options.length !== sel.length) continue;
        var match = true;
        for (var j = 0; j < sel.length; j++) { if (v.options[j] !== sel[j]) { match = false; break; } }
        if (match) return v;
      }
      return null;
    }

    function setPrice(txt) {
      ['#skg-price', '#skg-sticky-price', '#skg-final-price'].forEach(function (id) {
        var el = root.querySelector(id);
        if (el && txt) el.textContent = txt;
      });
    }

    function updateVariant(applyImage) {
      if (!root.querySelector('.skg-optset')) return; // single-variant product: keep Liquid defaults
      var sel = selectedValues();
      var v = findVariant(sel);
      var atc = root.querySelector('#skg-atc');
      if (v) {
        if (idInput) idInput.value = v.id;
        setPrice(v.price);
        if (v.image && applyImage) setMainImage(v.image, true);
        if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Add to Cart' : 'Sold Out'; }
      } else if (atc) {
        atc.disabled = true; atc.textContent = 'Unavailable';
      }
    }

    root.querySelectorAll('.skg-optset').forEach(function (set) {
      set.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn || !set.contains(btn)) return;
        set.querySelectorAll('[data-value]').forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-checked', 'false'); });
        btn.classList.add('on'); btn.setAttribute('aria-checked', 'true');
        var isColor = set.getAttribute('data-is-color') === 'true';
        if (isColor) {
          var label = root.querySelector('#skg-color-label');
          if (label) label.textContent = btn.getAttribute('data-value');
        }
        updateVariant(isColor);
      });
    });

    // Secondary CTAs scroll back to the buy box so the shopper picks size/color deliberately
    function toBuyBox() {
      var buyBox = root.querySelector('#skg-form') || root;
      buyBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    var stickyBtn = root.querySelector('#skg-sticky-btn');
    if (stickyBtn) stickyBtn.addEventListener('click', toBuyBox);
    var finalBtn = root.querySelector('#skg-final-btn');
    if (finalBtn) finalBtn.addEventListener('click', toBuyBox);

    // Review links scroll to the Judge.me widget section further down the template
    root.querySelectorAll('[data-to-jdgm]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var widget = document.querySelector('.jdgm-review-widget');
        if (!widget) return;
        e.preventDefault();
        widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Sticky bar visibility
    var sticky = root.querySelector('#skg-sticky');
    var atcBtn = root.querySelector('#skg-atc');
    if (sticky && atcBtn && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (en) {
        var e = en[0];
        var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('visible', passed);
      }, { threshold: 0 });
      obs.observe(atcBtn);
    }

    // FAQ accordion
    root.querySelectorAll('.faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.parentElement;
        var ans = item.querySelector('.faq-a');
        var open = item.classList.contains('open');
        root.querySelectorAll('.faq-item.open').forEach(function (i) { i.classList.remove('open'); i.querySelector('.faq-a').style.maxHeight = '0'; });
        if (!open && ans) { item.classList.add('open'); ans.style.maxHeight = ans.scrollHeight + 'px'; }
      });
    });

    // Size finder quiz
    var quiz = root.querySelector('#skg-squiz');
    if (quiz) {
      var recSize = 0;
      function showStep(k) {
        quiz.querySelectorAll('.squiz-step').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== k; });
      }
      function openQuiz() { quiz.hidden = false; document.body.style.overflow = 'hidden'; showStep('1'); }
      function closeQuiz() { quiz.hidden = true; document.body.style.overflow = ''; }
      root.querySelectorAll('.size-guide').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); openQuiz(); });
      });
      quiz.addEventListener('click', function (e) { if (e.target === quiz) closeQuiz(); });
      var qx = quiz.querySelector('#skg-squiz-close');
      if (qx) qx.addEventListener('click', closeQuiz);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !quiz.hidden) closeQuiz(); });
      quiz.querySelectorAll('[data-go]').forEach(function (b) {
        b.addEventListener('click', function () { showStep(b.getAttribute('data-go')); });
      });
      function toResult(size, note) {
        recSize = size;
        quiz.querySelector('#squiz-size').textContent = size + '"';
        quiz.querySelector('#squiz-note').textContent = note;
        showStep('result');
      }
      function calcFromInches() {
        var n = parseFloat(quiz.querySelector('#squiz-inches').value);
        if (!n || n <= 0) return;
        var sizes = [10, 12, 14, 16, 18, 20, 22, 24], s = null;
        for (var i = 0; i < sizes.length; i++) { if (n <= sizes[i]) { s = sizes[i]; break; } }
        if (n < 8) {
          toResult(10, 'The 10" is our smallest collar, made for necks from 8" to 10". At ' + n + '" it will fit loosely — measure again to be sure before ordering.');
        } else if (!s) {
          toResult(24, 'The 24" is our largest collar, for necks from 22" to 24". A ' + n + '" neck is beyond its range — reach out to us before ordering.');
        } else {
          toResult(s, 'A ' + n + '" neck sits comfortably in the ' + s + '" collar, which fits from ' + (s - 2) + '" to ' + s + '". Leave two fingers of room when fitting.');
        }
      }
      var calcBtn = quiz.querySelector('#squiz-calc');
      if (calcBtn) calcBtn.addEventListener('click', calcFromInches);
      var inchesInput = quiz.querySelector('#squiz-inches');
      if (inchesInput) inchesInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); calcFromInches(); } });
      quiz.querySelectorAll('[data-size]').forEach(function (b) {
        b.addEventListener('click', function () {
          var s = parseInt(b.getAttribute('data-size'), 10);
          toResult(s, 'Based on typical neck sizes for a dog of this weight (' + b.textContent.trim() + '). A quick measurement is always more accurate — the ' + s + '" fits necks from ' + (s - 2) + '" to ' + s + '".');
        });
      });
      var applyBtn = quiz.querySelector('#squiz-apply');
      if (applyBtn) applyBtn.addEventListener('click', function () {
        var match = null;
        root.querySelectorAll('.size-row [data-value]').forEach(function (b) {
          if (!match && b.getAttribute('data-value').indexOf(recSize + '"') === 0) match = b;
        });
        if (match) match.click();
        closeQuiz();
        var form = root.querySelector('#skg-form');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // Fade-in
    if ('IntersectionObserver' in window) {
      var fo = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); fo.unobserve(e.target); } });
      }, { threshold: 0.08 });
      root.querySelectorAll('.fi').forEach(function (el) { fo.observe(el); });
    } else {
      root.querySelectorAll('.fi').forEach(function (el) { el.classList.add('in'); });
    }

    updateVariant(false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();
})();
